import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import BaseController from '../BaseController'

@Controller({  component: 'layout-logout', fragment: 'auto-logout-inactivity' })
class AutoLogoutController extends BaseController {

  @OnClick({ target: 'button-log-in-again' })
  onClickLoginButton(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

}

export default AutoLogoutController;
